import React from "react";

/**
 * HAKKILO TECHNOLOGIES — logo mark
 * "H" structure: two navy lateral pillars + central gold figure (M shape) with
 * a gold sphere "head" above. Inspired by Peul roots, leadership and connection.
 */
export const Logo = ({ size = 44, variant = "dark", className = "" }) => {
  // variant "dark" → navy + gold (use on light backgrounds)
  // variant "light" → gold + light (use on dark navy backgrounds)
  const navy = variant === "light" ? "#F5F5F5" : "#0A1326";
  const gold = "#D4AF37";

  return (
    <svg
      width={size}
      height={size * 1.16}
      viewBox="0 0 120 140"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Hakkilo Technologies"
      data-testid="hk-logo"
    >
      {/* Left pillar — tapered bottom */}
      <path d="M18 32 H38 V108 L28 130 L18 108 Z" fill={navy} />

      {/* Right pillar */}
      <path d="M82 32 H102 V108 L92 130 L82 108 Z" fill={navy} />

      {/* Gold sphere — head */}
      <circle cx="60" cy="22" r="11.5" fill={gold} />
      {/* Tiny highlight on sphere */}
      <circle cx="56.5" cy="18.5" r="3" fill="#F0D77A" opacity="0.7" />

      {/* Gold central M figure — two arms reaching up + tapered column */}
      <path
        d="M40 50
           L60 68
           L80 50
           L80 70
           L66 70
           L66 110
           L60 124
           L54 110
           L54 70
           L40 70 Z"
        fill={gold}
      />

      {/* Inner gold shadow stroke for depth */}
      <path
        d="M60 68 L60 124"
        stroke="#B8941F"
        strokeWidth="0.8"
        opacity="0.5"
      />
    </svg>
  );
};

export const Wordmark = ({ className = "", variant = "light" }) => {
  // On dark navy header → variant="light" → light text
  const main = variant === "light" ? "#F5F5F5" : "#0A1326";
  const sub = "#D4AF37";

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="hk-wordmark">
      <Logo size={38} variant={variant} />
      <div className="leading-none">
        <div
          className="font-display tracking-[0.04em] text-[16px] font-extrabold"
          style={{ color: main }}
        >
          HAKKILO
        </div>
        <div
          className="font-display mt-1 text-[9px] tracking-[0.32em] font-semibold"
          style={{ color: sub }}
        >
          TECHNOLOGIES
        </div>
      </div>
    </div>
  );
};

export default Logo;
